import { render, staticRenderFns } from "./Zjjcxx.vue?vue&type=template&id=78b82bdb&scoped=true"
import script from "./Zjjcxx.vue?vue&type=script&lang=js"
export * from "./Zjjcxx.vue?vue&type=script&lang=js"
import style0 from "./Zjjcxx.vue?vue&type=style&index=0&id=78b82bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b82bdb",
  null
  
)

export default component.exports